module.exports = __webpack_public_path__ + "static/media/warning.a9fdf46b.svg";